import React from 'react';
import { createRoot, hydrateRoot, type Root } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SERVER_RENDERED_ROOT_ATTRIBUTE } from './config/serverRendering';

/**
 * Starts the app in the given container. Documents rendered at build time are
 * hydrated so their markup stays on screen; every other document (dev server,
 * 404, sign-in bridge, legal pages) only holds a text stub and is rendered
 * from scratch.
 */
export function mountMarketingApp(container: HTMLElement): Root {
  const app = (
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );

  if (container.hasAttribute(SERVER_RENDERED_ROOT_ATTRIBUTE)) {
    return hydrateRoot(container, app);
  }

  const root = createRoot(container);
  root.render(app);
  return root;
}
